import {whiteColor, blueColor, oceanBlueColor,  DodgerBlueColor} from '../../cmsMainStyle'

const drawingCardStyle = theme => ({
	root: {
		background:	"linear-gradient(0deg, " + whiteColor + ", " + DodgerBlueColor[1] + ")",
	},

	field: {
		display: "inline"
	},

	content: {
		display: "inline"
	},

	contentArea: {
		paddingBottom: theme.spacing(1),
	},

	cardActionBtn: {
		'&:hover': {
			color: blueColor[10]
		},
	}
})

export {drawingCardStyle}